const CLASSES = {
	TITLE_ACTION: 'title-action',
};

export default {
	CLASSES,
};
